module.exports = __webpack_public_path__ + "static/media/video2.227b174.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos-en/video2.mp4
// module id = 0eQu
// module chunks = 0